<template>
  <v-card
    class="ma-0"
    width="100%"
    style="height: auto"
    elevation="2"
  >
    <v-app-bar
      flat
      class="my-0 mb-6 py-1 px-2"
      dense
      height="30"
    >
      <v-toolbar-title class="mt-4 me-4">{{ $t($route.name) }}</v-toolbar-title>
      <div
        v-if="!isMobile && !isTablet"
        style="width: 230px;"
      >
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </div>
      <v-spacer />
      <v-btn
        v-if="selected.length > 0 && !isMobile"
        outlined
        @click="deletDialog = true"
        class="mt-4 ms-2"
        color="pink"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t('remove') }}
        </p>
        <v-icon>
          mdi-trash-can-outline
        </v-icon>
      </v-btn>
      <v-menu
        offset-y
      >
        <template v-slot:activator="{ attrs, on }">
          <v-btn
            outlined
            class="mt-4 px-1 ms-2"
            color="grey darken-2"
            height="32"
            v-bind="attrs"
            v-on="on"
            style="min-width: 35px !important;padding: 0 !important;"
          >
            <!-- <p class="mb-0 me-2">
              {{$t('more')}}
            </p> -->
            <v-icon>
              mdi-dots-vertical
            </v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item
            v-if="lockPermission && selected.length > 0"
            link
            @click="lockGroup('lock')"
          >
            <v-list-item-icon>
              <v-icon>mdi-lock-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('lock')" />
          </v-list-item>
          <log
            v-if="$store.state.permissions && $store.state.permissions.includes('logList')"
            ref="logRef"
            :type-prop="typeForm"
            :listProp="true"
            mode-prop="button"
          />
          <v-list-item
            v-if="isMobile || isTablet"
            link
            @click="getItems"
          >
            <v-list-item-icon>
              <v-icon>mdi-refresh</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('refresh')" />
          </v-list-item>
          <v-list-item
            v-if="isMobile || isTablet"
            link
            @getAllRows="getAllRows"
          >
          <export-excel
            ref="refExcel"
            :data="excelItems"
            worksheet="abriron.com"
            name="data.xls"
            type="xls"
            class="float-left d-flex"
            :title="$store.state.abrName"
            :total-prop="pageCount"
            :page-prop="excelPage"
            @getAllRows="getAllRows"
          >
            <v-list-item-icon>
              <v-icon>mdi-file-excel-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('excel')" />
          </export-excel>
          </v-list-item>
          <v-list-item
            v-if="isMobile || isTablet"
            link
            @click="printDialog = true"
          >
            <v-list-item-icon>
              <v-icon>mdi-printer-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('print')" />
          </v-list-item>
          <v-list-item
            v-if="isMobile || isTablet"
            link
            @click="goTo(typeForm)"
          >
            <v-list-item-icon>
              <v-icon>mdi-plus</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t(typeForm)" />
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="getItems"
        class="mt-4 px-1 ms-2"
        color="grey darken-2"
        height="32"
        @shortkey="getItems"
        v-shortkey="['f5']"
        style="min-width: 35px !important;padding: 0 !important;"
      >
        <!-- <p class="mb-0 me-2">
          {{$t('refresh')}}
        </p> -->
        <v-icon>
          mdi-refresh
        </v-icon>
      </v-btn>
      <export-excel
        v-if="!isMobile && !isTablet"
        ref="refExcel"
        :data="excelItems"
        worksheet="abriron.com"
        name="data-ai.xls"
        type="xls"
        class="float-left"
        :title="$store.state.abrName"
        :total-prop="pageCount"
        :page-prop="excelPage"
        @getAllRows="getAllRows"
      >
        <v-btn
          outlined
          class="mt-4 ms-2"
          color="grey darken-2 "
          height="32"
        >
          <p class="font-weight-thin mb-0 me-2">
            {{ $t('excel') }}
          </p>
          <v-icon>
            mdi-file-excel-outline
          </v-icon>
        </v-btn>
      </export-excel>
      <v-btn
        outlined
        @click="filter = true"
        class="mt-4 ms-2"
        color="grey darken-2 "
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t('filter') }}
        </p>
        <v-icon>
          mdi-filter-outline
        </v-icon>
      </v-btn>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="printDialog = true"
        class="mt-4  ms-2"
        color="grey darken-2"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t('print') }}
        </p>
        <v-icon>
          mdi-printer-outline
        </v-icon>
      </v-btn>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="goTo(typeForm)"
        class="mt-4 ms-2"
        color="primary"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t(typeForm) }}
        </p>
        <v-icon>
          mdi-plus
        </v-icon>
      </v-btn>
    </v-app-bar>
    <v-row
      v-if="isMobile || isTablet"
      class="mx-0"
    >
      <v-col
        class="mb-4 px-2"
        cols="12"
      >
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </v-col>
    </v-row>
    <v-row class="mx-0">
      <v-col
        v-show="!isMobile"
        class="px-1 py-0"
        cols="12"
        md="12"
      >
        <v-chip-group
          mandatory
          active-class="primary--text"
          class="justify-start"
          style="padding-top: 1px"
        >
          <v-chip outlined label>
            {{ $t('totalSum') }} : {{ $numberFormat((summary ? summary.amount : 0)) }} {{$store.state.currency.name}}
          </v-chip>
        </v-chip-group>
      </v-col>
    </v-row>
    <v-col
      cols="12"
      class="px-2"
    >
      <v-data-table
        v-if="headers"
        v-model="selected"
        :height="(isMobile || isTablet || mobileShow ? 323 : tableHeight)"
        fixed-header
        :headers="showHeaders"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        :page.sync="page"
        multi-sort
        dense
        :show-select="showSelect"
        item-key="id"
        :hide-default-header="isMobile || mobileShow"
        class="mb-2 td-hide-border"
        style="border: 1px solid #e3e3e3;border-radius: 6px;"
        :footer-props="{
          showFirstLastPage: (!mobileShow ? true : false),
          itemsPerPageOptions: [10, 25, 50, 100, 500],
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-plus',
          nextIcon: 'mdi-minus'
        }"
      >
        <template
          v-if="isMobile"
          v-slot:item="{ item, index }"
        >
          <tr>
            <td class="px-0">
              <v-list-item
                class="data-table-list-items px-0"
                :class="{
                  'mobile-td-list-border-red': (item.type == 'cost' ? true : false ),
                  'mobile-td-list-border-green': (item.type == 'income' ? true : false ),
                }"
                dense
              >
                <v-list-item-icon class="ps-2 me-1">
                  <div class="d-flex">
                    <p class="mt-3">
                      {{ +index + +1 }}
                    </p>
                    <v-menu
                      offset-y
                    >
                      <template v-slot:activator="{ attrs, on }">
                        <v-btn
                          color="primary"
                          v-bind="attrs"
                          icon
                          v-on="on"
                        >
                          <v-icon
                            medium
                          >
                            mdi-dots-vertical
                          </v-icon>
                        </v-btn>
                      </template>

                      <v-list dense>
                        <v-list-item
                          link
                          :disabled="(item.lock ? true : false)"
                          @click="edit(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-clipboard-edit</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('edit')" />
                        </v-list-item>
                        <v-list-item
                          link
                          @click="print('invoiceIncomePrint', item)"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-printer-outline</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('print')" />
                        </v-list-item>
                        <v-list-item
                          v-clipboard:copy="$baseURL + '/' + (typeForm == 'cost' ? 'cost':'income') +'/edit/' + item.id"
                          link
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-link</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('copy-link')" />
                        </v-list-item>
                        <log
                          :title-prop="$t('history')"
                          icon-prop="mdi-history"
                          :listProp="true"
                          :type-prop="typeForm"
                          :refIdProp="item.id"
                          mode-prop="button"
                        />
                        <v-list-item
                          v-show="removePermission(typeForm)"
                          link
                          :disabled="(item.lock ? true : false)"
                          @click="openDeleteDialog(item)"
                        >
                          <v-list-item-icon>
                            <v-icon color="pink">
                              mdi-trash-can-outline
                            </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('remove')" />
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="text-wrap">
                    {{ (item.account ? item.account.name : '') }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-wrap">
                    {{$t('account')}} : {{ (item.customer ? item.account.name : '')}}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap">
                    {{ $t('tax') }} : {{ $numberFormat(parseFloat(item.tax)) }} {{ item.currency.name }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap">
                    {{ $t('date') }} : {{ item.date }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap">
                    <div class="pt-1">
                      <v-chip
                        v-if="item.refund && parseFloat(item.refund) > 0"
                        class="mx-0 me-1"
                        color="red"
                        small
                        outlined
                      >
                        {{ $numberFormat(parseFloat(item.refund)) }}
                        <v-icon>
                          mdi-credit-card-refund-outline
                        </v-icon>
                      </v-chip>
                      <v-chip
                        v-if="item.customer_id && !item.bank_id"
                        class="mx-0"
                        :color="(item.remain > 0 ? 'red' : 'green')"
                        small
                        outlined
                      >
                        {{ (item.remain > 0 ? $t('remainPrice') + ' ' + $numberFormat(parseFloat(item.remain)) : $t('payed') ) }}
                      </v-chip>
                      <v-chip
                        v-if="item.bank_id"
                        class="mx-0"
                        color="green"
                        small
                        outlined
                      >
                        {{ $t('payed') }}
                      </v-chip>
                      <v-chip
                        v-for="(tag, index) in item.tags"
                        :key="index"
                        :color="tag.color"
                        label
                        small
                        style="margin-left: 1px;margin-right:1px"
                        class="px-1 mb-1"
                      >
                        <span class="px-1 white--text">
                          {{ tag.text }}
                        </span>
                      </v-chip>
                    </div>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="ms-1">
                  <v-btn
                    dark
                    text
                    small
                    color="primary"
                    @click="edit(item)"
                  >
                    {{ $numberFormat(parseFloat(item.price)) }} {{ item.currency.name }}
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </td>
          </tr>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-menu
            offset-y
          >
            <template v-slot:activator="{ attrs, on }">
              <v-btn
                color="primary"
                v-bind="attrs"
                icon
                v-on="on"
              >
                <v-icon
                  medium
                >
                  mdi-dots-vertical
                </v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item
                link
                :disabled="(item.lock ? true : false)"
                @click="edit(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-clipboard-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('edit')" />
              </v-list-item>
              <v-list-item
                v-if="lockPermission"
                link
                @click="lock(item, (item.lock ? 'unlock' : 'lock'))"
              >
                <v-list-item-icon>
                  <v-icon :color="(item.lock ? 'green' : 'pink')">{{(item.lock ? 'mdi-lock-open-outline' : 'mdi-lock-outline')}}</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="(item.lock ? $t('unlock') : $t('lock'))" />
              </v-list-item>
              <v-list-item
                v-show="type === 'income'"
                link
                @click="print('invoiceIncomePrint', item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-printer-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('print')" />
              </v-list-item>
              <v-list-item
                v-clipboard:copy="$baseURL + '/' + (typeForm == 'cost' ? 'cost':'income') +'/edit/' + item.id"
                link
              >
                <v-list-item-icon>
                  <v-icon>mdi-link</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('copy-link')" />
              </v-list-item>
              <log
                :title-prop="$t('history')"
                icon-prop="mdi-history"
                :listProp="true"
                :type-prop="typeForm"
                :refIdProp="item.id"
                mode-prop="button"
              />
              <v-list-item
                v-show="removePermission(typeForm)"
                link
                :disabled="(item.lock ? true : false)"
                @click="openDeleteDialog(item)"
              >
                <v-list-item-icon>
                  <v-icon color="pink">
                    mdi-trash-can-outline
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('remove')" />
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:item.user.name="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div
                v-if="item.user"
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
              >
                {{ item.user.firstname }}  {{ item.user.lastname }}
              </div>
            </template>
            <span>{{ item.time }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.price="{ item }">
          <a @click="edit(item)">
            {{ $numberFormat(parseFloat(item.price), (item.currency ? item.currency.decimal : 0)) }} {{ item.currency.name }}
            <v-chip
              v-if="item.refund && parseFloat(item.refund) > 0"
              class="mx-0 me-1"
              color="red"
              small
              outlined
            >
              {{ $numberFormat(parseFloat(item.refund)) }}
              <v-icon>
                mdi-credit-card-refund-outline
              </v-icon>
            </v-chip>
            <v-chip
              v-if="item.customer_id && !item.bank_id"
              class="mx-0"
              :color="(item.remain > 0 ? 'red' : 'green')"
              small
              outlined
            >
              {{ (item.remain > 0 ? $t('remainPrice') + ' ' + $numberFormat(parseFloat(item.remain)) : $t('payed') ) }}
            </v-chip>
            <v-chip
              v-if="item.bank_id"
              class="mx-0"
              color="green"
              small
              outlined
            >
              {{ $t('payed') }}
            </v-chip>
          </a>
        </template>
        <template v-slot:item.tax="{ item }">
          <a @click="edit(item)">
            {{ $numberFormat(parseFloat(item.tax), (item.currency ? item.currency.decimal : 0)) }} {{ item.currency.name }}
          </a>
        </template>
        <template v-slot:item.discount="{ item }">
          <a @click="edit(item)">
            {{ $numberFormat(parseFloat(item.discount), (item.currency ? item.currency.decimal : 0)) }} {{ item.currency.name }}
          </a>
        </template>
        <template v-slot:item.title="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                :color="item.last_status.status.color"
                text
                v-on="on"
                @click="edit(item)"
              >
                {{ item.title }}
              </v-btn>
            </template>
            <span>{{ $t('edit') }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.id="{ item }">
          <a @click="edit(item)">
            {{ item.id }}
          </a>
          <v-icon
            v-if="item.lock"
            color="red"
            style="font-size: 22px"
          >
            mdi-lock-outline
          </v-icon>
        </template>
        <template v-slot:item.row="{ item }">
          <a @click="edit(item)">
            {{ parseInt(items.indexOf(item))+ parseInt(from) }}
          </a>
        </template>
        <template v-slot:item.sub_type="{ item }">
          {{ (item.sub_type ? $t(item.sub_type) : '') }}
        </template>
        <template v-slot:item.plan="{ item }">
          <div class="pt-1">
            <v-chip
              v-if="item.plan"
              color="primary"
              label
              small
              style="margin-left: 1px;margin-right:1px"
              class="px-1 mb-1"
            >
              <span class="px-1 white--text">
                {{ item.plan.plan.name }}
              </span>
            </v-chip>
          </div>
        </template>
        <template v-slot:item.tags="{ item }">
          <div class="pt-1">
            <v-chip
              v-for="(tag, index) in item.tags"
              :key="index"
              :color="tag.color"
              label
              small
              style="margin-left: 1px;margin-right:1px"
              class="px-1 mb-1"
              @click="edit(item)"
            >
              <span class="px-1 white--text">
                {{ tag.text }}
              </span>
            </v-chip>
          </div>
        </template>
        <template v-slot:item.time="{ item }">
          {{ item.time }}
        </template>
        <template v-slot:item.ref_name="{ item }">
          <div class="pt-1">
            <v-chip
              v-if="item.ref_name"
              label
              outlined
              small
              style="margin-left: 1px;margin-right:1px"
              class="px-1 mb-1"
              @click="relationLink(item)"
            >
              {{ item.ref_name }}
            </v-chip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  v-if="item.ref_item_name"
                  label
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  small
                  color="primary"
                  style="margin-left: 1px;margin-right:1px;max-width: 100px"
                  class="px-1 mb-1"
                >
                  {{$t('product')}} {{ item.ref_item_name }}
                </v-chip>
              </template>
              <span>{{ item.ref_item_name}}</span>
            </v-tooltip>
            <div class="pt-1">
              <v-chip
                v-for="(integrate, index) in item.integrator"
                :key="index"
                color="green"
                label
                small
                style="margin-left: 1px;margin-right:1px"
                class="px-1 mb-1"
              >
              <span class="px-1 white--text">
                {{ $t(integrate.key) }}  | {{ $t('id') }} : {{ integrate.value }}
                {{ (integrate.number ? ' | ' + $t('number') + ':' + integrate.number : '' ) }}
              </span>
              </v-chip>
            </div>
          </div>
        </template>
        <template
          v-slot:body.append
        >
          <tr>
            <td
              :colspan="`${isMobile?6:Number(showHeaders.length)}`"
            >
              <div
                style="width: 100%;"
                class="pa-1"
              >
                <strong>{{ $t('sumInPage') }}</strong> :
                <v-chip
                  color="primary"
                  class="px-1"
                >
                <span class="px-1 white--text">
                  {{ $numberFormat(totals.sum) }}
                </span>
                </v-chip>
              </div>
            </td>
          </tr>
        </template>
        <template v-slot:footer.prepend>
          <v-col
            v-show="!isMobile"
            cols="1"
            class="pa-0"
            style="margin-top: -10px"
          >
            <v-text-field
              v-model.number="page"
              :label="$t('goToPage')"
              min="1"
              :max="pageCount"
              type="number"
              outlined
              height="32"
              hide-details
              hide-spin-buttons
              dense
              :suffix="'  /  ' + pageCount"
            />
          </v-col>
        </template>
      </v-data-table>
    </v-col>
    <v-row />
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="printDialog"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex pb-0"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="printDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('print') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <printnew
            ref="printRef"
            :header-prop="printHeaders"
            :items-prop="items"
            :dialog="printDialog"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="filter"
      width="70%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="filter = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('filter') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="detail"
              :title="$t(typeForm)"
              type="alldetail"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="account"
              title="account"
              type="person"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="bank"
              :title="$t('bank') + '/' + $t('cash')"
              type="bankCash"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <status
              v-model="sellStatus"
              :hideconfig="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <tag
              v-model="tag"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-select
              v-model="selectedHeaders"
              :items="headers"
              label="Select Columns"
              height="30"
              dense
              outlined
              multiple
              return-object
            >
              <template v-slot:selection="{ item, index }">
                <v-chip
                  v-if="index < 2"
                  small
                >
                  <span>{{ item.text }}</span>
                </v-chip>
                <v-chip
                  v-if="index === 1"
                  small
                >
                  <span>(+{{ selectedHeaders.length - 2 }} {{ $t('other') }})</span>
                </v-chip>
              </template>
            </v-select>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="branch"
              title="branch"
              type="branch"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <template>
              <v-text-field
                id="fromId"
                v-model="fromDate"
                :label="$t('from') + ' ' + $t('date')"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="fromDate"
                element="fromId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                auto-submit
                :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <template>
              <v-text-field
                id="toId"
                v-model="toDate"
                :label="$t('until') + ' ' + $t('date')"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="toDate"
                element="toId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                :min="fromDate"
                auto-submit
                :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-select
              v-model="lockStatus"
              :label="$t('lockStatusDocuments')"
              :items="lockStatusItems"
              height="30"
              dense
              outlined
              clearable
              item-value="value"
              item-text="text"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <money
              v-model="fromAmount"
              :dense="true"
              :label="$t('from') + ' ' + $t('amount')"
              :outlined="true"
              :solo="false"
              :clearable="true"
              value-when-is-empty=""
              :options="options"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <money
              v-model="toAmount"
              :dense="true"
              :label="$t('until') + ' ' + $t('amount')"
              :outlined="true"
              :solo="false"
              :clearable="true"
              value-when-is-empty=""
              :options="options"
            />
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                class=" mx-0"
                color="primary"
                @click="getItems"
              >
                {{ $t('filter') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left mx-0"
                @click="filter = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="taskDialog"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="taskDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('task') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="deletDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="deletDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('are-you-sure-delete-this-case') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
                @click="removegroup"
              >
                {{ $t('remove') }}
              </v-btn>
              <v-btn
                v-if="selected.length == 0"
                color="primary"
                @click="remove"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
    />
  </v-card>
</template>

<script>
  import Task from '../task/task'
  import General from '../../../../Mixins/general'
  export default {
    name: 'CostList',
    components: {
      Snakbar: () => import('../../components/general/snakbar/snakbar'),
      Tag: () => import('../../components/general/Tag/tag'),
      Status: () => import('../../components/general/Status/status'),
      Task,
    },
    mixins: [General],
    props: ['input', 'type', 'refId', 'mobileShow'],
    data: () => ({
      printHeaders: [],
      excelItems: [],
      selected: [],
      pageCount: 1,
      page: 1,
      detail: null,
      bank: null,
      account: null,
      fromAmount: null,
      toAmount: null,
      summary: null,
      printDialog: false,
      deletDialog: false,
      showSelect: true,
      filter: false,
      model: null,
      from: 1,
      fromDate: null,
      toDate: null,
      taskDialog: null,
      tag: null,
      temp: null,
      deleteItem: null,
      sellStatus: null,
      items: [],
      sortBy: [],
      selectedHeaders: [],
      dialog: null,
      timer: 0,
      totalItems: 0,
      snakbar: false,
      typeForm: null,
      subType: null,
      taskId: null,
      snakbarText: null,
      loading: true,
      options: {
        itemsPerPage: 5,
      },
      headers: null,
      search: null,
    }),
    computed: {
      isMobile () {
        return this.$vuetify.breakpoint.name === 'xs'
      },
      showHeaders () {
        var app = this
        return this.headers.filter(function (s) {
          return app.selectedHeaders.includes(s)
        })
      },
      totals: function () {
        var app = this
        const totals = this.items.reduce((acc, d, index) => {
          acc.sum += (d.price ? parseFloat(d.price) : 0)
          return acc
        }, {
          sum: 0,
        })
        app.renderTable = true
        return totals
      },
    },
    watch: {
      refId (val, oldVal) {
        // this.items = []
        this.getItems()
      },
      model () {
        this.$emit('input', this.model)
      },
      selected () {
        this.$emit('input', this.selected.text)
        if (this.selected.length > 0) {
          this.model = this.selected[0].text
          this.temp = this.selected[0].text
        }
        this.dialog = false
      },
      search () {
        var app = this
        app.loading = true
        app.page = 1
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.getItems()
        }, 1000)
      },
      options: {
        handler () {
          var app = this
          app.sortBy = []
          app.options.sortBy.map(function (value, key) {
            const index = app.headers.findIndex(h => h.value === value)
            app.sortBy.push(app.headers[index].table)
          })
          this.getItems()
        },
        deep: true,
      },
      sortBy () {
        const index = this.headers.findIndex(h => h.value === this.sortBy)
        if (index > -1) {
          this.sortBy = this.headers[index].table
        }
      },
    },
    beforeMount () {
      if (this.$route.name === 'costList') {
        this.typeForm = 'cost'
      } else if (this.$route.name === 'incomeList') {
        this.typeForm = 'income'
      } else if (this.$route.name === 'commissionList') {
        this.subType = 'commission'
        this.typeForm = 'cost'
      } else if (this.$route.name === 'penaltyList') {
        this.subType = 'penalty'
        this.typeForm = 'cost'
      } else if (this.$route.name === 'penaltyCancellingList') {
        this.subType = 'penaltyCancelling'
        this.typeForm = 'cost'
      } else if (this.$route.name === 'returnCommissionList') {
        this.subType = 'returnCommission'
        this.typeForm = 'income'
      } else if (this.$route.name === 'returnProcessingList') {
        this.subType = 'returnProcessing'
        this.typeForm = 'income'
      } else if (this.$route.name === 'processingList') {
        this.subType = 'processing'
        this.typeForm = 'cost'
      } else if (this.$route.name === 'shippingList') {
        this.subType = 'shipping'
        this.typeForm = 'cost'
      } else if (this.$route.name === 'returnShippingList') {
        this.subType = 'returnShipping'
        this.typeForm = 'income'
      } else if (this.$route.name === 'durabilityInEntrepotList') {
        this.subType = 'durabilityInEntrepot'
        this.typeForm = 'cost'
      } else if (this.$route.name === 'contradictionProductInEnterList') {
        this.subType = 'contradictionProductInEnter'
        this.typeForm = 'cost'
      }

      this.headers = [
        {
          text: this.$t('actions'),
          align: 'start',
          sortable: false,
          value: 'actions',
          width: 20,
        },
        {
          text: this.$t('row'),
          align: 'start',
          sortable: false,
          value: 'row',
          width: 20,
        },
        {
          text: this.$t('number') + ' ' + this.$t(this.typeForm),
          sortable: true,
          value: 'id',
        },
        {
          text: this.$t('document-number'),
          sortable: true,
          value: 'doc_header.number',
          table: 'doc_header.number',
        },
        {
          text: this.$t(this.typeForm + 'Type'),
          sortable: true,
          value: 'sub_type',
        },
        {
          text: this.$t(this.typeForm),
          sortable: true,
          value: 'account.name',
          table: 'financial_detail_coding.name',
        },
        {
          text: this.$t('account'),
          sortable: false,
          value: 'customer.name',
        },
        {
          text: this.$t('bank'),
          sortable: false,
          value: 'bank.name',
        },
        {
          text: this.$t('price'),
          sortable: true,
          value: 'price',
          table: 'cost_income.price',
        },
        {
          text: this.$t('tax'),
          sortable: true,
          value: 'tax',
          table: 'cost_income.tax',
        },
        {
          text: this.$t('discount'),
          sortable: true,
          value: 'discount',
          table: 'cost_income.discount',
        },
        {
          text: this.$t('date'),
          sortable: true,
          value: 'date',
          table: 'cost_income.date',
        },
        {
          text: this.$t('branch'),
          sortable: false,
          value: 'branch.name',
        },
        {
          text: this.$t('relation-whit'),
          sortable: false,
          value: 'ref_name',
        },
        {
          text: this.$t('tag'),
          sortable: false,
          value: 'tags',
        },
        {
          text: this.$t('description'),
          sortable: true,
          value: 'description',
          table: 'cost_income.description',
        },
        {
          text: this.$t('registerar'),
          sortable: false,
          value: 'user.name',
        },
      ]
      this.printHeaders = [
        {
          text: this.$t('number') + ' ' + this.$t(this.typeForm),
          value: 'id',
        },
        {
          text: this.$t('document-number'),
          value: 'doc_header.number',
        },
        {
          text: this.$t(this.typeForm + 'Type'),
          value: 'sub_type',
        },
        {
          text: this.$t(this.typeForm),
          value: 'account.name',
        },
        {
          text: this.$t('account'),
          value: 'customer.name',
        },
        {
          text: this.$t('bank'),
          value: 'bank.name',
        },
        {
          text: this.$t('date'),
          value: 'date',
        },
        {
          text: this.$t('branch'),
          value: 'branch.name',
        },
        {
          text: this.$t('tax'),
          value: 'tax',sum: true,
          type: 'number'
        },
        {
          text: this.$t('discount'),
          value: 'discount',sum: true,
          type: 'number'
        },
        {
          text: this.$t('price'),
          value: 'price',sum: true,
          type: 'number'
        },
      ];

    },
    activated () {
      // this.getItems()
    },
    mounted () {
      this.selectedHeaders = this.headers
      if (this.input) {
        this.model = this.input
      }
      this.getItems()
    },
    methods: {
      openDeleteDialog (item) {
        this.deleteItem = item
        this.deletDialog = true
      },
      openTaskDialog (item) {
        this.refId = item.rel_id
        this.taskId = item.id
        this.taskDialog = true
      },
      isEnabled (slot) {
        return this.enabled === slot
      },
      edit (item) {
        if (item.lock) {
          return false
        }
        this.$router.push({ name: this.typeForm + 'Edit', params: { id: item.id } })
      },
      relationLink (item) {
        this.$router.push({ name: item.ref_type + 'Edit', params: { id: item.ref_uid } })
      },
      getItems () {
        var app = this
        app.loading = true
        app.filter = false
        app.$axios.get(this.$endpoint + 'CostIncome', {
          params: {
            search: app.search,
            lockStatus: app.lockStatus,
            page: (app.allRows ? app.excelPage : app.options.page),
            refId: app.refId,
            branch: app.branch,
            type: app.type,
            subType: app.subType,
            fromDate: app.fromDate,
            toDate: app.toDate,
            sortBy: app.sortBy,
            options: app.options,
            tag: app.tag,
            typeForm: app.typeForm,
            detail: app.detail,
            account: app.account,
            bank: app.bank,
            fromAmount: app.fromAmount,
            toAmount: app.toAmount,
          },
        })
          .then(res => {
            res = res.data
            if (!app.allRows) {
              app.items = res.data
              app.totalItems = res.total
              app.pageCount = res.last_page
              app.from = res.from
              app.summary = res.summary
              app.creatExcelData(res.data)
            } else {
              app.generateExcellForAllData(res.data, res.last_page)
            }
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      lock (item, type) {
        this.selected = [item]
        this.lockGroup(type)
      },
      lockGroup (type) {
        var app = this
        app.loading = true
        var selected = []
        app.selected.map(function (value, key) {
          selected.push(value.id)
        })
        app.$axios.get(this.$endpoint + 'CostIncome', {
          params: {
            lock: 'active',
            id: selected,
            type: type,
          },
        })
          .then(res => {
            res = res.data
            app.snakbarText = this.$t('opertationSuccess')
            app.snakbarColor = 'green'
            app.snakbar = true
            app.getItems()
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(function () {
            app.loading = false
            app.selected = []
          })
      },
      remove () {
        var app = this
        if (!app.deleteItem) return false
        if (app.deleteItem.lock) {
          return false
        }
        app.loading = true
        app.$axios.delete(this.$endpoint + 'CostIncome/' + this.deleteItem.id)
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.getItems()
          })
          .finally(() => (app.loading = false))
      },
      removegroup () {
        var app = this
        app.loading = true
        var selected = []
        app.selected.map(function (value, key) {
          selected.push({ id: value.id })
        })
        app.$axios.get(this.$endpoint + 'CostIncome', {
          params: {
            deleteItems: selected,
          },
        })
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.selected = []
            app.getItems()
          })
          .finally(() => (app.loading = false))
      },
      print (to, item) {
        var routeData = this.$router.resolve({ name: to, params: { id: item.uid } })
        window.open(routeData.href, '_blank')
      },
      creatExcelData (data, type = 'page') {
        var app = this
        if (type === 'page') {
          app.excelItems = []
        }
        data.map(function (d) {
          app.excelItems.push({
            id: d.id,
            account: (d.account ? d.account.name : ''),
            customer: (d.customer ? d.customer.name : ''),
            bank: (d.bank ? d.bank.name : ''),
            amount: d.price,
            date: d.date,
            remain: (d.remain ? d.remain : ''),
            currency: (d.currency ? d.currency.name : ''),
            content: (d.description ? d.description : ''),
          })
        })
      },
    },
  }
</script>

<style scoped>
::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  white-space: nowrap;
}
::v-deep .v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 32px !important;
}
</style>
